<script>
	import { createEventDispatcher } from "svelte";
	const dispatch = createEventDispatcher();

	import { supports } from "./data";

	export let support;
	export let license;

	let list = [];
	let options = false;
	function showOptions() {
		if (!options) {
			list = license.supportOptions.map(a => supports[a]);
			setTimeout(() => (options = true), 100);
		}
	}

	function hideOptions(e) {
		options = false;
	}

	function selectOption(e) {
		let value = e.target.dataset.support;
		if (value) {
			dispatch("change", { value, license });
		}
	}
</script>

<svelte:body on:click={hideOptions} />
<span
	on:click={showOptions}
	class="name"
	class:selector={license.supportOptions.length}
	class:open={options}>
	<strong>{support.name}</strong>
</span>
{#if options}
	<ul on:click={selectOption}>
		{#each list as sobj}
			<li data-support={sobj.id}>
				{sobj.name + (sobj.price ? ` (${sobj.price}$)` : '')}
			</li>
		{/each}
	</ul>
{/if}

<style>
	.name {
		display: inline-block;
		text-transform: capitalize;
		position: relative;
		padding-right: 2rem;
		user-select: none;
	}
	.selector {
		cursor: pointer;
	}
	.selector:after {
		content: "";
		display: inline-block;
		width: 0;
		height: 0;
		margin-left: 12px;
		position: absolute;
		right: 0;
		top: 50%;
		margin-top: -2px;
		border: 5px solid transparent;
		border-top: 5px solid #000;
		box-sizing: border-box;
	}
	.selector.open:after {
		border-top-color: transparent;
		border-bottom: 5px solid #000;
		margin: 0 0 -2px 0;
		top: auto;
		bottom: 50%;
	}
	ul {
		display: block;
		box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
		position: absolute;
		top: 100%;
		left: 0;
		right: 0;
		z-index: 5;
	}
	li {
		background-color: #fff;
		box-sizing: border-box;
		border-top: 1px solid #dedede;
		cursor: pointer;
		padding: 10px;
	}
</style>
